import { memo } from 'react';

import { UniversalCommunicationObject } from '~/models/masterdata/UniversalCommunication';

export const PackageBasicRestrictionMessage = memo(() => {
  const { email, phone } = UniversalCommunicationObject.getSalesContact();

  const handleEmailClick = () => {
    globalThis.location.href = `mailto:${email}?subject=VESTIGAS-Vollversion`;
  };

  const handlePhoneClick = () => {
    globalThis.location.href = `tel:${phone}`;
  };

  return (
    <span>
      Diese Funktion ist nicht im Paket Basic enthalten. Bei Interesse an einer
      Vorstellung der höheren Pakete, kontaktiere uns über{' '}
      <span className="cursor-pointer font-bold" onClick={handleEmailClick}>
        {email}
      </span>{' '}
      oder{' '}
      <span className="cursor-pointer font-bold" onClick={handlePhoneClick}>
        {phone}
      </span>
      .
    </span>
  );
});

PackageBasicRestrictionMessage.displayName = 'PackageBasicRestrictionMessage';
